import css from "./Footer.module.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("footer");

  return (
    <footer className={css.footer} role="contentinfo">
      <div className={css.container}>
        <div className={css.brandCol}>
          <div className={css.logo}>ibhava</div>
          <p className={css.tag}>{t("phrase")}</p>
        </div>

        {/* <nav className={css.navCol} aria-label="Explorar">
          <div className={css.colTitle}>Explorar</div>
          <ul>
            <li>
              <Link to="/library">Biblioteca</Link>
            </li>
            <li>
              <Link to="/programs">Programas</Link>
            </li>
            <li>
              <Link to="/video/sample">Vídeos</Link>
            </li>
          </ul>
        </nav> */}

        {/* <div className={css.navCol} aria-label="Institucional">
          <div className={css.colTitle}>Institucional</div>
          <ul>
            <li>
              <Link to="/about">Sobre</Link>
            </li>
            <li>
              <Link to="/for-pros">Para profissionais</Link>
            </li>
            <li>
              <Link to="/contact">Contato</Link>
            </li>
          </ul>
        </div> */}

        <div className={css.navCol} aria-label="Legal">
          <div className={css.colTitle}>{t("legal")}</div>
          <ul>
            <li>
              <Link to="/terms">{t("terms.titleFooter")}</Link>
            </li>
            <li>
              <Link to="/privacy">{t("privacy.titleFooter")}</Link>
            </li>
            <li>
              <Link to="/cookies">{t("cookiesTitle")}</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={css.bottom}>
        <div>
          © {new Date().getFullYear()} ibhava — {t("developed")}{" "}
          <a target="blank" href="https://thiagorocha.ibhava.com/">
            Dr. Thiago Rocha
          </a>
        </div>
      </div>
    </footer>
  );
}
